import { useMemo } from 'react';

import { COUNTRY_REGIONS } from '@frontend/addresses';
import { Select, type SelectProps } from '@frontend/legacy-components';

type Region = {
  name: string;
  abbreviation: string;
  type?: string;
};

export type CountryRegionData = {
  regions: Region[];
  postalCodeLabel?: string;
  regionLabel?: string;
};

export type RegionSelectProps = Omit<SelectProps, 'value'> & {
  country?: string; // country abbreviation
  value?: string; // region abbreviation
};

export const RegionSelect = ({
  country,
  value,
  ...props
}: RegionSelectProps) => {
  const countryRegions = useMemo(() => {
    return (
      COUNTRY_REGIONS[country as keyof typeof COUNTRY_REGIONS]?.regions ?? []
    );
  }, [country]);
  const regionOptions = useMemo(() => {
    return countryRegions.map(({ abbreviation, name }) => ({
      label: name,
      value: abbreviation,
    }));
  }, [countryRegions]);
  return (
    <Select
      isDisabled={!countryRegions.length}
      placeholder=""
      options={regionOptions}
      value={regionOptions.find((c) => c.value === value) ?? ''}
      {...props}
    />
  );
};
